import type { ReactNode } from 'react';
import { Header } from './_shared';

export type SingleColumnSlideProps = {
  eyebrow: ReactNode;
  title?: ReactNode;
  body: ReactNode;
  /** Optional full-height image panel on the right. */
  image?: { src: string; alt: string };
  /** Optional extra class on the slide-body root, for deck-local scoping. */
  className?: string;
};

export function SingleColumnSlide({ eyebrow, title, body, image, className }: SingleColumnSlideProps) {
  return (
    <div className={`slide-body${className ? ` ${className}` : ''}`}>
      <Header eyebrow={eyebrow} title={title} />
      <div className={`sn-work${image ? ' sn-work--with-image' : ''}`}>
        <div className="sn-body-1col">{body}</div>
        {image && (
          <div className="sn-image-panel">
            <img src={image.src} alt={image.alt} />
          </div>
        )}
      </div>
    </div>
  );
}
